import { http } from '../../config/axios'

export default function deleteClienteDocumento(id: string): Promise<void> {
  return http
    .delete(`api/client/documento/${id}`)
    .then(() => {})
    .catch((error) => {
      console.error('Erro deleteClienteDocumento', error)
      throw Error(error.response?.data || 'Erro ao excluir documento')
    })
}
